import { useState, useEffect } from 'react';
import { GooglePaySettings } from '../types/quickPay';

interface GooglePayConfigResult {
  config: GooglePaySettings | null;
  loading: boolean;
  error: string | null;
}

export const useGooglePayConfig = (): GooglePayConfigResult => {
  const [config, setConfig] = useState<GooglePaySettings | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await fetch('/checkout/GetGooglePayConfig', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch Google Pay config: ${response.status}`);
        }

        const data = await response.json();
        setConfig(data);
      } catch (err) {
        console.error('Error fetching Google Pay configuration:', err);
        setError(err instanceof Error ? err.message : 'Unknown error');
        setConfig({ enabled: false } as GooglePaySettings); // Fallback to disabled
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, []);

  return { config, loading, error };
}; 